// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2zUGG","productName":"Table_productName__3doJ6"};